import { useState, useMemo, useEffect } from 'react';
import { useIsMounted } from 'src/shared/hooks/useIsMounted';
import { useLocalStorage } from 'src/shared/hooks/useLocalStorage';
import { LocalStorageKeys } from 'src/shared/models/enums/localStorageKeys.enum';
import SearchField from 'src/shared/components/form/searchField';
import { PageFilterSection } from 'src/shared/components/organisms/pageFilterSection';
import { DEFAULT_PAGE_INDEX, DEFAULT_PAGE_SIZE } from 'src/shared/models/enums/gridFilterConfig';
import { EInvoiceReceiverSearchFilter } from '../models/eInvoiceReceiverSearchFilter';
import { EInvoiceReceiverDataGrid } from '../components/eInvoiceReceiverDataGrid';

export const EInvoiceReceiverOverviewPage = () => {
  const isMounted = useIsMounted();
  const [tempSearchString, setTempSearchString] = useState<string | undefined>(undefined);
  const [searchInitialized, setSearchInitialized] = useState<boolean>(false);

  const [receiverSearchFilter, setReceiverSearchFilter] = useLocalStorage(LocalStorageKeys.EInvoiceReceiverFilter, {
    sortCol: 'id',
    sortDir: 'desc',
    pageIndex: DEFAULT_PAGE_INDEX,
    pageSize: DEFAULT_PAGE_SIZE,
  } as EInvoiceReceiverSearchFilter);

  const searchFilter: EInvoiceReceiverSearchFilter = useMemo(() => {
    return {
      filter: receiverSearchFilter?.filter,
      pageSize: receiverSearchFilter?.pageSize,
      pageIndex: receiverSearchFilter?.pageIndex,
      sortCol: receiverSearchFilter?.sortCol,
      sortDir: receiverSearchFilter?.sortDir,
    } as EInvoiceReceiverSearchFilter;
  }, [
    receiverSearchFilter?.filter,
    receiverSearchFilter?.pageIndex,
    receiverSearchFilter?.pageSize,
    receiverSearchFilter?.sortCol,
    receiverSearchFilter?.sortDir,
  ]);

  useEffect(() => {
    if (isMounted() && searchInitialized) {
      if (tempSearchString === '') {
        setReceiverSearchFilter((prev) => ({ ...prev, ...{ filter: '', pageIndex: 0 } }));
      }
      if (tempSearchString && tempSearchString.length >= 2) {
        setReceiverSearchFilter((prev) => ({ ...prev, ...{ filter: tempSearchString, pageIndex: 0 } }));
      } else {
        setReceiverSearchFilter((prev) => ({ ...prev, ...{ filter: '', pageIndex: 0 } }));
      }
    }
  }, [isMounted, searchInitialized, setReceiverSearchFilter, tempSearchString]);

  return (
    <>
      <PageFilterSection
        leftContent={
          <SearchField
            initialValue={searchFilter.filter || ''}
            onSearch={(newSearchString) => {
              setSearchInitialized(true);
              setTempSearchString(newSearchString);
            }}
          />
        }
      />
      <EInvoiceReceiverDataGrid
        searchFilter={searchFilter}
        searchFilterCallback={(newFilter) =>
          setReceiverSearchFilter((prev) => ({
            ...prev,
            ...newFilter,
          }))
        }
      />
    </>
  );
};
